import { Sticky, StickyContainer } from "react-sticky";
import { BasePage } from "../../../../framework/pages/BasePage";
import { Tabs } from "antd";
import { DetalleMuestreoModal } from "../../tabs/DetalleMuestreoModal";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { FunctionUtil } from "../../../../util/FunctionUtil";
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";
import { AgregarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/AgregarEstacionModal";
import { EditarEstacionModal } from "../../../servicios-ejecutados/tabs/PlanificacionSejecutados/modals/EditarEstacionModal";
import { MessageUtil } from "../../../../util/MessageUtil";
import { LoadUtil } from "../../../../framework/util/LoadUtil";
import { RequestUtil } from "../../../../util/RequestUtil";
import { EnvConstants } from "../../../../EnvConstants";
import ConfigurarPuntosSection from "../../tabs/ConfigurarPuntosSection";
import ProcedenciaMuestraModal from "../../tabs/ProcedenciaMuestraModal";
import EquiposUtilizadosModal from "../../tabs/EquiposUtilizadosModal";
import OtrosDatosModal from "../../tabs/OtrosDatosModal";
import DatosServisiosModal from "../../tabs/DatosServisiosModal";
import { ModalContext } from "../../../../provider/ModalProvider";
import { COLUMN_DEFAULT } from "../../../../framework/grid/GridFw";
import { ParametrosModal } from "../../../atc/servicios-oma/cadenas-custodia/modals/ParametrosModal";
import { ParametrosCadenaModal } from "../../modals/ParametrosCadenaModal";
import { DateUtil } from "../../../../util/DateUtil";

class CadenaIluminacionPage extends BasePage {
  static contextType = ModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id_doc: null,
      keyPanel: "1"
    }
    this.cambiarTabPanel = this.cambiarTabPanel.bind(this)
  }

  cambiarTabPanel(tab, id_doc) {
    this.setState({
      id_doc: id_doc,
      keyPanel: tab,
      keyPrincipal: tab,
    })
  }

  renderPage(pageApi, keyPanel) {
    const getgrid_detalle_muestreo = () => pageApi.getComponent('gridDetalleMuestreo');
    const getgrid_resultados_parametros = () => pageApi.getComponent('gridResultadosParametros');
    const getform_campos_entrevista = () => pageApi.getComponent('form_campos_entrevista');
    const getFormVerificacionEquipos = () => pageApi.getComponent("formVerificacionEquipos");
    const { TabPane } = Tabs;

    const fnUpdateItem = (data) => {
      this.context.hideModal();
      getgrid_detalle_muestreo().saveItemEditing();
      const arrMuestreo = getgrid_detalle_muestreo().getData();

      setTimeout(() => {
        arrMuestreo.forEach(el => {
          if (data.key == el.key) {
            getgrid_detalle_muestreo().updateItem({
              ...el,
              id_estacion: data.id_estacion,
              estaciondes: data.estaciondes,
              descripcion: data.descripcion,
              COORDF: data.COORDF,
              COORDN: data.COORDN,
            })
          } else {
            getgrid_detalle_muestreo().updateItem(el)
          }
        });
      }, 0)
    }

    const ConfigEstacionModal = (data, esNuevo = true, id_estacion = 0) => {
      const { showModal } = this.context;
      let obj = {};

      obj = {
        fnUpdateItem,
        data: {
          ...data,
          id_tipo_matriz: getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz,
          id_empresa: getgrid_detalle_muestreo()?.itemEditing.id_empresa,
          id_estacion: id_estacion
        },
      };

      showModal({
        title: esNuevo ? "Agregar Estación" : "Editar Estación",
        width: 350,
        maskClosable: true,
        closable: false,
        background: 'white',
        component: esNuevo ? <AgregarEstacionModal name={obj} getParentApi={pageApi.getApi} /> : <EditarEstacionModal name={obj} getParentApi={pageApi.getApi} />
      });
    };

    const ConfiguracionModalConfig = (data) => {
      const { showModal } = this.context;
      let obj = {};
      obj = { ...obj, ...data };
      
      showModal({
        width: 800,
        maskClosable: false,
        component: <ParametrosCadenaModal name={obj} getParentApi={pageApi.getApi} />
      });
    };

    const gridDetalleMuestreo = (pageApi) => ({
      layout: "vertical",
      title: "Detalles de muestreo",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      rowId: "id_muestreo",
      load: {
        search: true,
        queryId: 936,
        params: () => {
          return {
            ID_CADENA: pageApi.getParamId(),
            id_doc: pageApi.name?.id_ss,
          };
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 895,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, "");
             getgrid_resultados_parametros().load(); 
            } 
        },    
      },
      fields: [
        {
          type: 'select', name: 'id_estacion', labelName: 'estaciondes', label: 'Estación', column: 3, load: {
            queryId: 846,
            params: () => { return { id_empresa: getgrid_detalle_muestreo()?.itemEditing?.id_empresa, id_tipo_matriz: getgrid_detalle_muestreo()?.itemEditing?.id_tipo_matriz } },
          }, search: true, editable: true,

          onChange: async (value, values, formApi) => {
            if (value == 0) {
              ConfigEstacionModal(formApi.getData(), true)
              formApi.setFieldData('id_estacion', null);
              formApi.setFieldData('descripcion', null);
              formApi.setFieldData('COORDF', null);
              formApi.setFieldData('COORDN', null);
            } else if (value == -1) {
              const id_estacion = getgrid_detalle_muestreo()?.itemEditing.id_estacion
              const estaciondes = getgrid_detalle_muestreo()?.itemEditing.estaciondes

              if (!id_estacion) {
                formApi.setFieldData('id_estacion', null);
                formApi.setFieldData('estaciondes', null);
                formApi.setFieldData('descripcion', null);
                formApi.setFieldData('COORDF', null);
                formApi.setFieldData('COORDN', null);
                return MessageUtil(
                  "warning",
                  "Advertencia",
                  "Debe seleccionar primero una estaciòn para poder editar."
                );
              }

              fnUpdateItem({ ...formApi.getData(), id_estacion, estaciondes })
              ConfigEstacionModal({ ...formApi.getData(), id_estacion, estaciondes }, false, id_estacion)
              formApi.setFieldData('id_estacion', id_estacion);
              formApi.setFieldData('estaciondes', estaciondes);
            } else {
              const id_estacion = value;
              let label = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.label;
              let descripcion = formApi?.getFieldApi('id_estacion')?.getSelectedItem()?.descripcion;

              const reqParams = LoadUtil.getReqParams({
                queryId: 138,
                params: {
                  ID_ESTACION: id_estacion
                },
              });

              const data = await RequestUtil.postData(EnvConstants.GET_URL_READ(), reqParams)
                .then((resp) => resp.dataObject)
                .catch(() => []);

              formApi.setFieldData('COORDF', data?.COORDF);
              formApi.setFieldData('COORDN', data?.COORDN);
              formApi.setFieldData('id_estacion', value);
              formApi.setFieldData('estacionDes', label || formApi.values.label);
              formApi.setFieldData('descripcion', descripcion || formApi.values.descripcion);

              if (formApi.values.id_estacion !== value) {
                fnUpdateItem({
                  ...formApi.getData(),
                  id_estacion,
                  estaciondes: label,
                  descripcion,
                  COORDF: data?.COORDF,
                  COORDN: data?.COORDN,
                })
              }
            }
          }
        },
        { name: "descripcion", label: "Descripción" },
        {
          type: "date",
          name: "fecha_prevista_muestreo",
          label: "Fecha Muestreo",
          editable: true,
          format: "DD/MM/YYYY",
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_inicio_muestreo",
          label: "Hora Muestreo",
          editable: true,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
        { type: 'date', name: "fecha_recoleccion", label: "Fecha Recolección", editable: true, format: 'DD/MM/YYYY', inputFormat: DATE_FORMAT.YYYYMMDD, },
        { type: 'date', name: "hora_recoleccion", label: "Hora Recolección", editable: true, format: DATE_FORMAT.HHmm, inputFormat: DATE_FORMAT.HHmm },
        { name: "matriz", label: "Tipo de matriz" },
        { name: "georeferencia", label: "Georeferencia" },
        { name: "zona_altitud", label: "Altitud/Zona" },
        {
          type: "number",
          name: "cant_envases",
          label: "Cant. Envases",
          editable: true,
        },
        { name: "Act_rea_trabajador", label: "Actividades Realizadas Trabajador", editable: true, }, 
        {
          ...COLUMN_DEFAULT.EXPERIMENT,
          title: "Ver Análisis",
          label: "Opciones",
          onClick: (value, row, index) => {
            ConfiguracionModalConfig(row);
          },
        }
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridResultadosParametros = (pageApi) => ({
      title: 'Detalle de muestreo insitu',
      showIndex: true,
      autoLoad: true,
      rowId: "id_insitu",
      pagination: {
        server: false,
        showSizeChanger: true,
      },      
      load: {
        queryId: 891,
        params: () => {
          return {
            id_cadena: pageApi.getParamId(),
          }
        },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 892,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: (resp) => {   
            if (resp?.dataObject == 1) {
            MessageUtil("error", resp.message, "");
            }
            else { 
            MessageUtil("success", resp.message, "");
            } 
        },
      },
      fields: [
        { name: "codigo_muestra", label: "Cod. Muestra" },
        { name: "parametro", label: "Método" },
        { name: "estacion", label: "Estación" },
        { name: 'georeferencia', label: 'Ubicación Geográfica', editable: false },
        {
          name: 'lux_max', label: 'Lux (max)', type: 'number', editable: true, onChange: (value, values, formApi) => {
            const resultado = (value + values.lux_min) / 2;
            formApi?.setFieldData('resultado', isNaN(resultado) ? '' : resultado);
          }
        },
        {
          name: 'lux_min', label: 'Lux (min)', type: 'number', editable: true, onChange: (value, values, formApi) => {
            const resultado = (values.lux_max + value) / 2;
            formApi?.setFieldData('resultado', isNaN(resultado) ? '' : resultado);
          }
        },
        { name: 'resultado', label: 'Promedio', type: 'text', readOnly: true, editable: true },
        {
          ...COLUMN_DEFAULT.ADD,
          label: "Replicar",
          color: "red",
          column: 12,
          onClick: async (value, row, index) => {
            await getgrid_resultados_parametros().saveItemEditing();
            await getgrid_resultados_parametros().refresh();
            const replicar = getgrid_resultados_parametros()
              .getData()
              .map((data) => {
                data.fecha_prevista_muestreo = row.fecha_prevista_muestreo;
                data.hora_inicio_muestreo = row.hora_inicio_muestreo;
                data.zonificacion = row.zonificacion;
                data.fuente_ruido = row.fuente_ruido;
                data.tiempo_medicion = row.tiempo_medicion;
                return data;
              });
            getgrid_resultados_parametros().setData(replicar);
          },
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const form_campos_entrevista = (pageApi) => ({ 
      layout: "vertical",
      autoLoad: true, 
      load: {
        queryId: 960,
        params: { ID_CADENA: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
      },
      save: {
        queryId: 961,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      fields: [ 
      {
      label: "Entrevista del Trabajador",
      fields: [
        { type: "hidden", name: "id_empresa" },
        { name: "nombre_trabajador", label: "Nombres y Apellidos", column: 4, },
        {
          type: "select",
          name: "sexo_trabajador",
          label: "Sexo",
          column: 1,
          // editable: true,
          load: {
          dataList: [
              { value: "F", label: "F" },
              { value: "M", label: "M" },
            ],
          },
        },
        { name: "turno_trabajador", label: "Turno de trabajo", column: 4, },
        { type:'number',name: "edad_trabajador", label: "Edad", column: 1, },
        { name: "rotativo_trabajador", label: "Rotativo/Frecuencia", column: 3, },
        { name: "puesto_trabajador", label: "Puesto de Trabajo", column: 3, },
        { name: "area_trabajador", label: "Area de monitoreo", column: 3, },
        { name: "desc_area_trabajador", label: "Descripcion del Area de monitoreo y/o trabajo", column: 4, },
        {
          type: "select",
          name: "usa_lentes_trabajador",
          label: "¿Usa Lentes?",
          column: 2,
          // editable: true,
          load: {
          dataList: [
              { value: "SI", label: "SI" },
              { value: "NO", label: "NO" },
            ],
          },
        },
        { name: "antiguedad_trabajador", label: "Antiguedad en el puesto", column: 3, },
        { name: "luzN_trabajador", label: "Luz Natural", column: 3, },
        { name: "luzA_trabajador", label: "Luz Artificial", column: 3, },
        { name: "cant_luz_trabajador", label: "Cantidad de fuentes de luz", column: 3, },
        { name: "epp_equipo_proteccion", label: "EPP Equipo de Proteccion Personal", column: 4, },
        { type: 'divider', label: 'Seleccion Grafico Lugar de Medicion' }, 
        { type: 'radio', name: "es_alturaM", label: "Imagen Altura de la Mesa", column: 3, load: { dataList: [ { value: '1', label: 'Si' }, { value: '0', label: 'No' } ] } },
        { name: "desc_alturaM", label: "Valor", column: 3, },
        { type: 'radio', name: "es_areaT", label: "Imagen área de trabajo", column: 3, load: { dataList: [ { value: '1', label: 'Si' }, { value: '0', label: 'No' } ] } },
        { name: "desc_areaT", label: "Valor", column: 3, },
      ],
      },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      }, 
    });
   
    const renderTabBar = (props, DefaultTabBar) => (
      <Sticky bottomOffset={80}>
        {({ style }) => (
          <DefaultTabBar
            {...props}
            className="site-custom-tab-bar"
            style={style}
          />
        )}
      </Sticky>
    );

    const gridsConfigDetalleMuestreo = [
      {
        name: "gridDetalleMuestreo",
        config: gridDetalleMuestreo(pageApi),
        type: 'grid'
      },
      {
        name: "gridResultadosParametros",
        config: gridResultadosParametros(pageApi),
        type: 'grid'
      },
     {
        name: "form_campos_entrevista",
        config: form_campos_entrevista(pageApi),
        type: 'form'
      },
    ];

    const formVerificacionEquipos = (pageApi) => ({
      layout: "vertical",
      load: {
        queryId: 956,
        params: { ID_CADENA: pageApi.getParamId() },
      },
      save: {
        queryId: 957,
        hideMessage: true,
        hideMessageError: true,
        params: { ID_CADENA: pageApi.getParamId() },
        fnOk: () => {
          getFormVerificacionEquipos().load();
        },
      },
      title: "Verificación del Equipo en Campo",
      collapsible: true,
      fields: [ 
        {
          name: "valor_verificacion_inicial",
          label: "Valor de la verificación inicial",
          column: 4,
        },
        {
          type: "date",
          name: "fecha_verificacion_inicial",
          label: "Fecha",
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
          column: 4,
        },
        {
          type: "date",
          name: "hora_verificacion_inicial",
          label: "Hora",
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
          column: 4,
        },
        {
          name: "valor_verificacion_final",
          label: "Valor de la verificación Final",
          column: 4,
        },
        {
          type: "date",
          name: "fecha_verificacion_final",
          label: "Fecha",
          column: 4,
          format: DATE_FORMAT.YYYYMMDD,
          inputFormat: DATE_FORMAT.YYYYMMDD,
        },
        {
          type: "date",
          name: "hora_verificacion_final",
          label: "Hora",
          column: 4,
          format: DATE_FORMAT.HHmm,
          inputFormat: DATE_FORMAT.HHmm,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    });

    const gridsEquipos = [
      {
        name: "formVerificacionEquipos",
        config: formVerificacionEquipos(pageApi),
        type: "form",
      },
    ];

    return (
      <StickyContainer>
        <Tabs destroyInactiveTabPane={true} activeKey={this.state.keyPanel} renderTabBar={renderTabBar} onChange={(key) => this.setState({ keyPanel: key })}>
          <TabPane tab="Configurar Puntos" key="1">
            <ConfigurarPuntosSection api={pageApi} name={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Datos del Servicio" key="2" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DatosServisiosModal api={pageApi} name={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Procedencia de la muestra" key="3" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <ProcedenciaMuestraModal api={pageApi} name={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>

          <TabPane tab="Detalle del muestreo" key="4" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <DetalleMuestreoModal api={pageApi} data={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} gridsConfig={gridsConfigDetalleMuestreo} />
          </TabPane>

          <TabPane 
          tab="Equipos Utilizados" 
          key="5" 
          disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}
          >
            <EquiposUtilizadosModal 
            api={pageApi} 
            name={{...pageApi.name}}
            cambiarTabPanel={this.cambiarTabPanel} 
            history={this.props.history} 
            gridsConfig={gridsEquipos}
            />
          </TabPane>

          <TabPane tab="Otros Datos" key="6" disabled={parseInt(pageApi.getParamId()) === 0 ? true : false}>
            <OtrosDatosModal api={pageApi} name={{...pageApi.name}} cambiarTabPanel={this.cambiarTabPanel} history={this.props.history} />
          </TabPane>
        </Tabs>
      </StickyContainer>
    );
  }
}

export default withRouter(CadenaIluminacionPage);